import styled from 'styled-components'

import { atMd, fromLg } from '@syconium/little-miss-figgy'

export const SvgWrapper = styled.div<{
  index: number
  pastIndex: number
}>`
  width: 254px;

  ${fromLg} {
    width: 383px;
  }

  ${atMd} {
    width: 287px;
  }

  #image_wrapper_0 {
    y: ${o => (o.index === 0 ? '22.0405' : '-680')};
    transition: all 0.5s ease-in-out;
  }

  #image_wrapper_1 {
    y: ${o => (o.index === 1 ? '22.0405' : o.index > o.pastIndex ? '-680' : '720')};
    transition: all 0.5s ease-in-out;
  }

  #image_wrapper_2 {
    y: ${o => (o.index === 2 ? '22.0405' : o.index > o.pastIndex ? '-680' : '720')};
    transition: all 0.5s ease-in-out;
  }

  #image_wrapper_3 {
    y: ${o => (o.index === 3 ? '22.0405' : '720')};
    transition: all 0.5s ease-in-out;
  }
`
